export const formatSynergyColorId = (numDecks: number, potentialDecks: number, synergy: number) =>
  potentialDecks > 0 ? `${((numDecks / potentialDecks - synergy) * 100).toFixed(0)}%` : 'N/A'
